import { useMemo } from "react";
import { useRoutes as renderRoutes } from "react-router-dom";

import NormalRoutes from "@/routes/NormalRoutes";
import AdminRoutes from "@/routes/AdminRoutes";

const useRoutes = () => {

    const routes = useMemo(() => {

        return [...NormalRoutes, ...AdminRoutes];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return renderRoutes(routes);
};

export default useRoutes;
